import {ShiftTemplate} from '@app/core/models/shift-template.model';

export interface IShiftTemplatesState {
	shiftTemplates: ShiftTemplate[];
	copyingWeek: any[];
	isLoading: boolean;
}

export const initialShiftTemplatesState: IShiftTemplatesState = {
	shiftTemplates: [],
	copyingWeek: [],
	isLoading: false,
};
